import AppleIcon from "@mui/icons-material/Apple";
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import Iconify from "../iconify";

export default function TopPurchaseProductsTable(props) {
	return (
		<TableContainer component={Paper}>
			<Table sx={{ minWidth: 650 }} aria-label="simple table">
				<TableHead>
					<TableRow>
						<TableCell></TableCell>
						<TableCell>Product ID</TableCell>
						<TableCell>Units</TableCell>
						<TableCell>Revenue</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{props?.users?.map((row, index) => (
						<TableRow
							key={index}
							sx={{
								"&:last-child td, &:last-child th": { border: 0 },
							}}
						>
							<TableCell component="th" scope="row">
								{row.store === 0 ? <AppleIcon /> : <Iconify icon={"eva:google-outline"} />}
							</TableCell>
							<TableCell component="th" scope="row">
								{row.productId}
							</TableCell>
							<TableCell component="th" scope="row">
								{row.purchaseCount}
							</TableCell>
							<TableCell component="th" scope="row">
								{row.totalPrice / 100} {"$"}
							</TableCell>
						</TableRow>
					))}
				</TableBody>
			</Table>
		</TableContainer>
	);
}
